import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ProjectDetailAttendees } from "../../common/styled/project";
import { toast } from "react-toastify";
import { useMediaQuery } from "react-responsive";
import { isOutsideCmpny, isSameUser } from "../../../../scheduler/component/function/common";
import { MdClose } from "react-icons/md";

const Participants = ({
  participantList = [],
  project = {},
  participant = {},
  changeModalState,
  showParticipants,
  setShowParticipants,
}) => {
  const user = useSelector((state) => state?.user?.data?.[0]);
  const company = useSelector((state) => state?.company?.data);
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const [participants, setParticipants] = useState({});

  useEffect(() => {
    setParticipants(groupParticipants(participantList));
  }, [participantList]);

  const groupParticipants = (list) =>
    list.reduce((acc, mber) => {
      acc[mber.orgNo] = acc[mber.orgNo] || { orgNm: mber.orgNm, orgNo: mber.orgNo, mber: [] };
      acc[mber.orgNo].mber.push(mber);
      return acc;
    }, {});

  const isMyCompanyProject = (orgNo) =>
    project.gbn === "G" || parseInt(project.orgNo) === parseInt(orgNo);

  const handleInviteClick = () => {
    if (
      !participant?.projectParticipantNo ||
      (isOutsideCmpny(project, company) && !isSameUser(user, project))
    ) {
      toast.error("초대 권한이 존재하지 않습니다.");
      return;
    }
    setShowParticipants(false);
    changeModalState("invite");
  };

  return (
    <ProjectDetailAttendees
      style={{ transform: `translateX(${!isMobile || showParticipants ? "0%" : "100%"})` }}>
      {isMobile && <div className="bg" onClick={() => setShowParticipants(false)} />}
      <div className="list">
        <p>참여자</p>
        <ul>
          {Object.entries(participants).map(([orgNo, { orgNm, mber }]) => (
            <li key={orgNo} className={isMyCompanyProject(orgNo) ? "" : "outside"}>
              <div className="orgName">{orgNm || "회사명 미설정"}</div>
              <ul>
                {mber.map(({ mberNo, mberNm, imgPath, orgNo: memberOrgNo }) => (
                  <li key={mberNo}>
                    <img
                      src={imgHandler(imgPath, false)}
                      onError={(e) => (e.target.src = "/img/icon_function_2.png")}
                      alt="참여자 이미지"
                    />
                    <div className="userInfo">
                      <span className={mberNo === user?.mberNo ? "my" : ""}>{mberNm}</span>
                      {project.gbn === "C" && project.orgNo !== memberOrgNo && (
                        <span>(외부업체)</span>
                      )}
                    </div>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
        <div className="actions">
          <button onClick={handleInviteClick}>참여자 초대</button>
          {user.mberNo === project.mberNo && (
            <button onClick={() => changeModalState("kick")}>참여자 관리</button>
          )}
        </div>
      </div>
    </ProjectDetailAttendees>
  );
};

export default Participants;
